import angular, { IHttpResponse } from 'angular'
import { RestResponse, RestOptions } from '../../../comun/js--base--unimat--local'
import { $unibase } from '../uni-base-module'
import { NotificacionService } from './NotifService'
import { RestProxy } from './rest-proxy'

type TErrorArgs = {
  mensaje?: string
}
export class AccesoServicios {
  _urlBaseServiciosRoot: string = ''
  constructor(
    private $http: ng.IHttpService,
    private $log: ng.ILogService,
    private $q: ng.IQService,
    private $resource: ng.resource.IResourceService,
    private NotifService: NotificacionService
  ) {
    var transformResponseDefault =
      this.$http.defaults.transformResponse && this.$http.defaults.transformResponse instanceof Array
        ? this.$http.defaults.transformResponse[0]
        : this.$http.defaults.transformResponse

    if (transformResponseDefault) {
      let _transformDefault = transformResponseDefault as unknown as angular.IHttpResponseTransformer

      var transformError = function (data: any, headersGetter: angular.IHttpHeadersGetter, status: number) {
        if ((status === 417 || status === 406) && typeof data === 'string') {
          try {
            angular.fromJson(data)

            // es json, no tratarlo
          } catch (e) {
            // es solo un mensaje
            return {
              statusText: data,
            }
          }
        }

        return _transformDefault(data, headersGetter, status)
      }
      this.$http.defaults.transformResponse instanceof Array &&
        (<ng.IHttpResponseTransformer[]>this.$http.defaults.transformResponse).unshift(transformError)
    }
  }

  gestionaErrorServiciosDeprecated(deferred: unknown, errorArgs: null | TErrorArgs[], msg: string) {
    this.$log.warn('** deprecated')

    if (errorArgs && errorArgs.length) {
      // puede ser un arguments, tiene más de 1 elemento
      var data = errorArgs[0]

      if (data.mensaje) {
        msg = msg + ':\n\n' + data.mensaje
      } else {
        // no hay mensaje, caso especial
        if (errorArgs.length > 1 && '403' == (errorArgs[1] as any)) {
          // es un acceso denegado
          msg = msg + ':\n\n' + '*** Acceso denegado para esta operación ***'
        }
      }
    }

    this.NotifService.alert(msg)
  }

  error(deferred: unknown, errorArgs: null | TErrorArgs[], msg: string) {
    return this.gestionaErrorServicios(deferred, errorArgs, msg)
  }

  /**
   * Este método por defecto limpia el loading
   *
   */
  gestionaErrorServicios(deferred: unknown, errorArgs: null | TErrorArgs[], msg: string) {
    // errorArgs es [ data, status, headers, config ]

    this.intentaGestionar(deferred, errorArgs, msg).then((gestionado) => {
      gestionado || this.gestionaErrorServiciosDeprecated(deferred, errorArgs, msg)
    })
  }

  private intentaGestionar(deferred: unknown, errorArgs: null | unknown[], msg: string): RestResponse<boolean> {
    return this.NotifService && this.gestionaErrorNotif(deferred, errorArgs, msg)
  }

  private gestionaErrorNotif(deferred: unknown, errorArgs: null | unknown[], msg: string) {
    this.NotifService.loading.clear()

    // gestionando por notificación
    return this.NotifService.error(deferred, errorArgs, msg)
  }

  // xhr es [ config, data, headers, status, statusText ]
  resourceErrorHandler(xhr: ng.resource.IResourceResponse, defaultMsg: string) {
    // jsc 20171108 gestionar en notifservice
    if (xhr && angular.isDefined(xhr.data) && NotificacionService) {
      this.gestionaErrorServicios(null, [xhr.data, xhr.status, xhr.headers, xhr.config], defaultMsg)
      return
    }

    if (xhr) {
      if (xhr.data && xhr.data.mensaje) defaultMsg = defaultMsg + '\n\n' + xhr.data.mensaje
      else if (xhr.data && xhr.data.statusText) defaultMsg = defaultMsg + '\n\n' + xhr.data.statusText
      else if (xhr.statusText) defaultMsg = defaultMsg + '\n\n' + xhr.statusText
    }

    this.NotifService.alert(defaultMsg)
  }

  defaults(defaultMsg: string, defaultUrl?: string, extraOps?: any) {
    return this.resourceDefaults(defaultMsg, defaultUrl, extraOps)
  }

  resourceDefaults(defaultMsg: string, defaultUrl?: string, extra?: ng.resource.IActionDescriptor[]) {
    var defaultInterceptor: ng.resource.IResourceInterceptor = {
      // requestError: (rejection: any) => {
      //   this.resourceErrorHandler(rejection, defaultMsg)
      //   return this.$q.reject(rejection)
      // },
      // response: <T>(response: IHttpResponse<T>) => {
      //   this.$log.debug(response)

      //   return response
      // },
      responseError: (rejection) => {
        this.resourceErrorHandler(rejection, defaultMsg)

        return this.$q.reject(rejection)
      },
    }

    // this.$http.defaults.transformResponse.unshift(transformError);

    var opts = {
      get: {
        method: 'GET',
        interceptor: defaultInterceptor,
      },
      save: {
        method: 'PUT',
        interceptor: defaultInterceptor,
      },
      add: {
        method: 'POST',
        interceptor: defaultInterceptor,
      },
      query: {
        method: 'GET',
        isArray: true,
        interceptor: defaultInterceptor,
      },
      remove: {
        method: 'DELETE',
        interceptor: defaultInterceptor,
      },
      delete: {
        method: 'DELETE',
        interceptor: defaultInterceptor,
      },
      savebatch: {
        method: 'PUT',
        isArray: true,
        url: defaultUrl && defaultUrl + '/batch',
        interceptor: defaultInterceptor,
      },
    }

    if (extra) {
      // incorporar el interceptor a los actions extra
      angular.forEach(extra, (action) => {
        action.interceptor = action.interceptor || defaultInterceptor
      })

      opts = angular.extend(opts, extra)
    }

    return opts
  }

  test() {
    this.NotifService.alert('test')
  }

  _get<R>(url: string, config?: angular.IRequestShortcutConfig, errorMsg?: string) {
    return this._callParams<R>('get', url, null, config, errorMsg)
  }

  get<R>(url: string, config?: angular.IRequestShortcutConfig, errorMsg?: string) {
    return this._get<R>(url, config, errorMsg)
  }

  _call<R>(method: string, url: string, data: any, queryParams: any, errorMsg: string, options?: RestOptions) {
    return this._callParams<R>(
      method,
      url,
      data,
      {
        cache: false,
        params: queryParams,
      },
      errorMsg,
      options
    )
  }

  call<R>(method: string, url: string, data: any, queryParams: any, errorMsg: string, options?: RestOptions) {
    return this._call<R>(method, url, data, queryParams, errorMsg)
  }

  _callParams<R>(
    method: string,
    url: string,
    data: any,
    config?: angular.IRequestShortcutConfig,
    errorMsg?: string,
    options?: RestOptions
  ): RestResponse<R> {
    var deferred = this.$q.defer<R>()

    let _m = method.toLowerCase()

    var response: RestResponse<ng.IHttpResponse<R>> | null = null

    if ('get' == _m) {
      response = this.$http.get(url, config)
    } else if ('post' == _m) {
      response = this.$http.post(url, data, config)
    } else if ('put' == _m) {
      response = this.$http.put(url, data, config)
    } else if ('delete' == _m) {
      response = this.$http.delete(url, config)
    }

    if (response) {
      response
        .then((xhr) => {
          // xhr => dataResponse, status, headers, config

          this.$log.debug(xhr)

          deferred.resolve(xhr.data)
        })
        .catch((xhr: IHttpResponse<R>) => {
          // xhr => data, status, headers, config

          /* xhr es 
                            config : {method: "GET", transformRequest: Array(1), transformResponse: Array(2), paramSerializer: ƒ, jsonpCallbackParam: "callback", …}
                            data : {timestamp: 1520598927804, status: 400, error: "Bad Request", exception: "org.springframework.web.method.annotation.MethodArgumentTypeMismatchException", message: "Failed to convert value of type 'java.lang.String'…rmatException: For input string: "listnovedadess"", …}
                            headers : ƒ (d)
                            status : 400
                            statusText : "400"
                            xhrStatus : "complete"
                        */

          // gestionar el error si nadie dice lo contrario
          let _gestionaerror = !options || !options._cfg || !options._cfg.nogestionaerror

          _gestionaerror &&
            this.NotifService.error(
              deferred,
              [xhr.data, xhr.status, xhr.headers, xhr.config],
              this.__mejoraError(errorMsg, xhr) || 'Error en la operación'
            )

          deferred.reject(xhr)
        })
    } else {
      this.NotifService.alert('LLamada incorrecta al método ' + method)

      deferred.reject('** error')
    }

    return deferred.promise
  }

  private __mejoraError(errorMsg: string, xhr: any) {
    if (errorMsg) return errorMsg

    try {
      if (xhr && xhr.data && xhr.data.path && xhr.data.message && (xhr.data.message as string).startsWith('PRIV--'))
        return (xhr.data.message as string).substring(6)
    } catch (err) {
      console.warn('No se puede obtener msg en xhr', err)
    }
  }

  /** HttpClient */
  _restrequest<R>({
    method,
    url,
    queryParams,
    data,
    options,
    copyFn,
  }: {
    method: string
    url: string
    queryParams?: any
    data?: any
    options?: RestOptions
    copyFn?: (data: R) => R
  }): RestResponse<R> {
    return this._call<R>(method, this._urlBaseServiciosRoot + url, data, queryParams, '', options)
  }

  _proxyUrl(baseUrl: string) {
    return new RestProxy(this, baseUrl)
  }
}

$unibase.service('AccesoServicios', AccesoServicios)

export default AccesoServicios
